import { Request } from '~src/httpClient/serverApi/requests/Request';
import { IEmptyResult } from '~src/httpClient/serverApi/types/IResponse';

import { LinkedTaskItem } from '../types/LinkedTaskItem';

export type CreateLinkedTaskParams = {
  readonly scheduleId: string;
  readonly linkedTaskItems: LinkedTaskItem[];
}

export class CreateLinkedTaskRequest extends Request<CreateLinkedTaskParams, IEmptyResult> {
  constructor(params: CreateLinkedTaskParams) {
    super('createLinkedTask', params);
  }
}
